import { cn } from '@realtyfeed/utils';

type ComponentSpinnerProps = {
  className?: string;
  size?: number;
};

export function ComponentSpinner({ className, size = 36 }: ComponentSpinnerProps) {
  return (
    <div className={cn('flex items-center justify-center', className)}>
      <span
        className="inline-block animate-spin rounded-full border-2 border-slate-300 border-t-cyan-500 dark:border-slate-700"
        style={{ width: size, height: size }}
        role="status"
        aria-label="Loading"
      />
    </div>
  );
}

type FallbackSpinnerProps = {
  logoSrc?: string;
  className?: string;
};

export function FallbackSpinner({ logoSrc, className }: FallbackSpinnerProps) {
  return (
    <div
      className={cn(
        'flex h-screen w-screen flex-col items-center justify-center gap-4 bg-slate-50 dark:bg-slate-950',
        className
      )}
    >
      {logoSrc ? <img src={logoSrc} alt="logo" className="h-10" /> : null}
      <ComponentSpinner />
      {/* The label is inlined rather than reached for via `LoadingData` — that
          component imports `ComponentSpinner` from this file, so importing it
          back here would close a cycle. Keep the copy in step with it. */}
      <p className="text-center text-sm font-bold text-slate-700 dark:text-slate-300">Loading...</p>
    </div>
  );
}
